if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

(() => {
  const syncQuadDriveStockCopy = () => {
    document.querySelectorAll('[data-qds-root]').forEach((root) => {
      const variantsEl = root.querySelector('[data-qds-variants]');
      if (!variantsEl) return;

      let variants;
      try {
        variants = JSON.parse(variantsEl.textContent || '[]');
      } catch (error) {
        return;
      }

      const byFinish = (finish) =>
        variants.find((variant) => String(variant.option1 || variant.title || '').toLowerCase() === finish);
      const gray = byFinish('gray');
      const silver = byFinish('silver');
      const grayAvailable = Boolean(gray && gray.available);
      const silverAvailable = Boolean(silver && silver.available);

      let copy = {
        hero: 'Choose your finish',
        sticky: 'Finish availability shown at checkout',
        title: 'Choose the finish that fits your setup.',
        body: 'Availability updates from the selected product variant before checkout.',
        restockFinish: '',
      };

      if (grayAvailable && silverAvailable) {
        copy = {
          hero: 'Gray and Silver ship now',
          sticky: 'Gray and Silver in stock',
          title: 'Gray and Silver are in stock and ready to ship.',
          body: 'Choose either finish today; checkout uses the selected in-stock variant.',
          restockFinish: '',
        };
      } else if (silverAvailable) {
        copy = {
          hero: 'Silver ships now',
          sticky: 'Silver in stock',
          title: 'Silver is in stock and ready to ship.',
          body: 'Gray is currently sold out. Choose Silver today or join the Gray restock list.',
          restockFinish: 'Gray',
        };
      } else if (grayAvailable) {
        copy = {
          hero: 'Gray ships now',
          sticky: 'Gray in stock',
          title: 'Gray is in stock and ready to ship.',
          body: 'Silver is currently sold out. Choose Gray today or join the Silver restock list.',
          restockFinish: 'Silver',
        };
      } else {
        copy = {
          hero: 'Join the restock list',
          sticky: 'Restock list open',
          title: 'QuadDrive is currently sold out.',
          body: 'Join the restock list and we will notify you as soon as a finish is available.',
          restockFinish: 'QuadDrive',
        };
      }

      const heroBadge = root.querySelector('.qds-hero__proof span:last-child');
      if (heroBadge) heroBadge.textContent = copy.hero;

      const stockPanel = root.querySelector('.qds-stock-panel');
      if (stockPanel) {
        const title = stockPanel.querySelector('strong');
        const body = stockPanel.querySelector('span');
        const link = stockPanel.querySelector('a');

        if (title) title.textContent = copy.title;
        if (body) body.textContent = copy.body;

        if (link) {
          if (copy.restockFinish) {
            link.hidden = false;
            link.textContent =
              copy.restockFinish === 'QuadDrive' ? 'Join the restock list' : `Join ${copy.restockFinish} restock list`;
            link.href = `mailto:hello@raidendigit.com?subject=${encodeURIComponent(
              `QuadDrive ${copy.restockFinish} restock notification`
            )}`;
          } else {
            link.hidden = true;
          }
        }
      }

      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      if (stickyPrice && stickyPrice.parentElement) {
        const stickyLine = stickyPrice.parentElement;
        stickyLine.replaceChildren(stickyPrice, ` launch bundle \u00b7 SSDs sold separately \u00b7 ${copy.sticky}`);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncQuadDriveStockCopy);
  } else {
    syncQuadDriveStockCopy();
  }
})();
